import { LoanApplicationService } from "../../services/LoanApplication";
import { CustomLoaderFunctionArgs } from "../../shared/router/RouteLoader";
import { getUserInfoFromLocalStorage } from "../../shared/services/Fetch";
import { ORG_IDS } from "../../shared/utils/constants";

export async function loader({
  params,
  pageName,
  getToken,
}: CustomLoaderFunctionArgs) {
  const userInfo=getUserInfoFromLocalStorage();
  let type = userInfo.organizationID == ORG_IDS.MFL ? "MFL_Sanctions" : "Sanctions";
  const [sanctionDetails, sanctionConditions, sanctionConditionFile] =
    await Promise.all([
      LoanApplicationService.getSanctions({
        loanApplicationID: params?.loanID as string,
        pageName: pageName!,
        page: 1, 
        token: getToken(),
        type: [type],
        limit: 10,
        sourceEntityID: params?.sourceEntityID as string,
      }),
      LoanApplicationService.getSanctionConditions({
        loanApplicationID: params?.loanID as string,
        pageName: pageName!,
        token: getToken(),
        type: [type],
        sourceEntityID: params?.sourceEntityID as string,
      }),
      LoanApplicationService.getSanctionConditionFile({
        loanApplicationID: params?.loanID as string,
        pageName: pageName!,
        token: getToken(),
        sourceEntityID: params?.sourceEntityID as string,
      }),
    ]);
  return { sanctionDetails, sanctionConditions, sanctionConditionFile };
}
